const routes = [
    {
        path: "/special-talent/online/registration/login",
        component: () => import("../pages/Login"),
    },
    {
        path: "/special-talent/online/registration",
        component: () => import("../pages/Index"),
        meta: {
            isSpecialTalentOnlineRegistration: true
        }
    },
    {
        path: "/special-talent/online/registration/success",
        component: () => import("../pages/Success"),
    }
];

export default routes;
